// Recovered compiled webpack factory 81259. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { M: () => n });
  let n = "10.47.0";
}
